import store from 'config/store'
import { receiveAgentMessage, setActiveConversation, setHasForcedConversation } from 'modules/conversations/actions'
import { Message } from 'types/message'

export const evaluateLiveViewMessage = (message: Message) => {
  const { id = null, conversationId = null } = message

  if (!conversationId || !id)  {
    return
  }

  // The message is coming directly from an agent to assign them as the sender so they can resolve within the UI
  const liveViewMessageAttributes = {
    ...message.attributes,
    senderId: message.authorId
  }

  const liveViewMessage = {
    ...message,
    attributes: liveViewMessageAttributes
  }

  store.dispatch(setActiveConversation({ conversationId }))
  store.dispatch(setHasForcedConversation())
  store.dispatch(receiveAgentMessage({ message: liveViewMessage }))
}
